export const normalizeEmail = (value?: string): string =>
  value?.toLowerCase().replace(/\s+/g, "") ?? ""
